<template>
  <v-form :submit="submitUpdate">
    <v-row>
      <v-col cols="12" md="6">
        <v-text-field
                      label="Código Referência"
                      v-model="value.ref"
                      hide-details
                      density="compact"></v-text-field>
      </v-col>
      <v-col cols="12" md="6">
        <AutocompleteSelectCashflowCategory
                                            :user="user"
                                            v-model="value.cashflow_category"
                                            :returnObject="true"
                                            :multiple="false"
                                            :rules="rules.required"
                                            label="Rubrica (categoria)"
                                            density="compact"
                                            :types="[
                                              $CASH_FLOW_CATEGORY_TYPES_DIC['IN'].value,
                                              $CASH_FLOW_CATEGORY_TYPES_DIC['BOTH'].value,
                                            ]" />
      </v-col>
      <v-col cols="12" md="6">
        <AutocompleteSelectCreateLegalPerson
                                             :user="user"
                                             label="Pessoa destino"
                                             v-model="value.legal_person_to"
                                             :multiple="true"
                                             density="compact" />
      </v-col>
      <v-col cols="12" md="6">
        <AutocompleteSelectSubGroup v-if="modelValue.id == null"
                                    :user="user"
                                    label="Grupos/Tropas"
                                    v-model="value.people_from_subgroup_ids"
                                    :returnObject="false"
                                    :multiple="true"
                                    density="compact" />
      </v-col>
      <!-- <v-col cols="12" md="4" sm="6">
        <AutocompleteSpecialFilters
          v-model="value.special_filter"
          :lstObjects="$SPECIAL_FILTERS_NEW_INVOICE"
          label="Filtros especiais"
          :multiple="false"
        />
      </v-col> -->

      <v-col cols="12" md="4">
        <v-text-field
                      label="Valor R$"
                      v-model="value.amount"
                      type="number"
                      :rules="rules.required"
                      hide-details
                      density="compact"></v-text-field>
      </v-col>
      <v-col cols="12" md="4">
        <v-text-field
                      label="Desconto R$"
                      v-model="value.early_payment_discount"
                      clearable
                      type="number"
                      hide-details
                      density="compact"></v-text-field>
      </v-col>

      <v-col cols="12" md="4">
        <v-menu v-model="dDateMenu" :close-on-content-click="false">
          <template v-slot:activator="{ props }">
            <v-text-field
              label="Data de vencimento"  
              v-bind="props"
              :value="formattedDueDate"
              :model-value="$moment(value.due_date?.substring(0, 10)).format('YYYY-MM-DD')"
              readonly
              :rules="rules.required"
              hide-details
              density="compact"
            />
          </template>
          <v-date-picker
            :model-value="dueDateAsDate"
            @update:model-value="updateDueDate"
          />
        </v-menu>
      </v-col>
      <v-col cols="12" md="6" v-if="modelValue.id == null">
        <v-text-field
                      label="Parcelas"
                      v-model="value.quantity"
                      type="number"
                      :rules="rules.required"
                      hide-details
                      density="compact"></v-text-field>
      </v-col>
      <v-col cols="12" md="6" v-if="modelValue.id == null">
        <AutocompleteSpecialFilters
                                    v-model="value.interval"
                                    :lstObjects="$SPECIAL_FILTERS_NEW_INVOICE_INTERVALS"
                                    :multiple="false"
                                    label="Intervalo"
                                    density="compact" />
      </v-col>
      <v-col cols="12" md="6" v-if="modelValue.id == null">
        <AutocompleteSelectEvent :user="user" label="Evento" v-model="value.event" return-object />
      </v-col>
      <v-col cols="12">
        <v-text-field
                      label="Descrição"
                      v-model="value.description"
                      hide-details
                      density="compact"></v-text-field>
      </v-col>
      <v-col cols="12" class="text-right">
        <v-btn color="info" type="button" density="compact" @click="submitUpdate(true)" class="m-2">
          <v-icon class="mr-2">mdi-content-save</v-icon>
          Salvar e Baixar
        </v-btn>
        <v-btn color="success" type="submit" density="compact">
          <v-icon class="mr-2">mdi-content-save</v-icon>
          Salvar
        </v-btn>
      </v-col>
    </v-row>
  </v-form>
</template>
<script>
import AutocompleteSelectCashflowCategory from "./AutocompleteSelectCashflowCategory.vue";
import AutocompleteSelectCreateLegalPerson from "./AutocompleteSelectCreateLegalPerson.vue";
import AutocompleteSelectGroup2 from "./AutocompleteSelectGroup2.vue";
import AutocompleteSelectSubGroup from "./AutocompleteSelectSubGroup.vue";
import AutocompleteSpecialFilters from "./AutocompleteSpecialFilters.vue";
import AutocompleteSelectEvent from "./AutocompleteSelectEvent.vue";
import api from '@/services'
export default {
  components: {
    AutocompleteSelectCreateLegalPerson,
    AutocompleteSelectCashflowCategory,
    AutocompleteSpecialFilters,
    AutocompleteSelectSubGroup,
    AutocompleteSelectGroup2,
    AutocompleteSelectEvent
  },
  props: {
    user: Object,
    modelValue: Object,
  },
  emits: ["update:modelValue", "created", "updated", "writeoff"],
  data() {
    return {
      requestingApi: null,
      dDateMenu: false,
      rules: {
        required: [(v) => !!v || "Campo obrigatório"],
        required0: [(v) => (v == null || v != 0 && !!v || v < 0) || "Campo obrigatório e deve ser maior que zero"],
      },
    };
  },
  created() { },
  mounted() {
    var vm = this;
    if (!vm.modelValue?.id) {
      vm.value = vm.generateEmpty();
    } else {
      vm.value.legal_person_from = vm.getGroupLegalPerson();
    }
  },
  methods: {
    updateDueDate(date) {
      const vm = this;
      vm.value.due_date = this.$moment(date).format('YYYY-MM-DD')
      this.dDateMenu = false;
    },
    submitUpdate(writeoff = false) {
      var vm = this;

      if (!vm?.modelValue?.cashflow_category) {
        vm.$notify({
          type: "warn",
          text: "Selecione a Rubrica!",
        });
        return;
      }
      if (vm.modelValue.quantity > 1 && !vm.modelValue.interval) {
        vm.$notify({
          type: "warn",
          text: "Para gerar mais de uma é necessário informar um intervalo!",
        });
        return;
      }

      if ((!vm.modelValue.legal_person_to || vm.modelValue.legal_person_to.length == 0) && vm.modelValue.people_from_subgroup_ids.length == 0 && !vm.modelValue.special_filter) {
        vm.$notify({
          type: "warn",
          text: "Selecione pelo menos um filtro de destino",
        });
        return;
      }
      vm.requestingApi = true;
      return new Promise((resolve, reject) => {
        const method = vm.modelValue?.id ? 'update' : 'create';

        api.invoice[method]({
          ...vm.modelValue,
          type: vm.$INVOICE_TYPE_DIC.INVOICE.value
        })
          .then((result) => {
            if (writeoff) {
              vm.$emit("writeoff", result);
            } else if (vm.modelValue?.id) {
              vm.$emit("updated", result);
            } else {
              vm.$emit("created", result);
            }
            vm.$notify({
              type: "success",
              text: "Dados alterados com sucesso",
            });
          })
          .catch((err) => {
            if (err.message) {
              vm.$notify({
                type: "warn",
                text: err.message,
              });
            }
          })
          .finally(() => {
            vm.requestingApi = false;
          });
      });
    },
    getGroupLegalPerson() {
      const vm = this;
      const _groupLegalPerson = api.storage.selectedGroup()?.legal_person || null;

      if (_groupLegalPerson) {
        const customName = `${_groupLegalPerson?.name} - ${_groupLegalPerson?.ssn}`;

        _groupLegalPerson.customName = customName;
      } else {
        vm.$notify({
          type: "warn",
          text: "Nenhum grupo selecionado (ou grupo selecionado sem pessoa vinculada)",
        });
      }
      return _groupLegalPerson;
    },
    generateEmpty() {
      const vm = this;

      return {
        legal_person_from: vm.getGroupLegalPerson(),
        legal_person_to: [],
        amount: null,
        early_payment_discount: null,
        ref: null,
        description: null,
        notes: null,
        due_date: vm.$moment(new Date()).format('YYYY-MM-DD'),
        quantity: 1,
        interval: null,
        people_from_subgroup_ids: [],
        special_filters: [],
        cashflow_category: null,
        type: vm.$INVOICE_TYPE_DIC.INVOICE.value
      };
    }
  },
  computed: {
    hasAdminAccess() {
      return this.user.access_level >= this.$USER_ACCESS_LEVELS_DIC.GROUP_ADMIN.value;
    },dueDateAsDate() {
      return this.value.due_date ? new Date(this.value.due_date) : new Date();
    },
    formattedDueDate() {
      return this.value.due_date ? this.$moment(this.value.due_date.substring(0, 10)).format('DD/MM/YYYY') : '';
    },
    value: {
      get() {
        return this.modelValue;
      },
      set(value) {
        this.$emit("update:modelValue", value);
      },
    },
  },
  watch: {},
};
</script>